import {BaseModelService} from './BaseModelService';
import {Product} from '../Models';

export class ProductService extends BaseModelService<Product> {
  constructor(apiUrl: string = '') {
    super(Product);
    this.apiBaseUrl = `${apiUrl}/v1/inventory/public/products`;
  }

  async listOnSiteProducts(eventId: number|string): Promise<Array<Product>> {
    return this.listCached<Product>('dependencies/on-site-products', {eventId});
  }
}
